import { StyleSheet } from "react-native";

export const styles = StyleSheet.create({
  container: {
    flex   : 1,
    width  : "100%",
    height : "100%",
  },
  inputContainer: {
    flexDirection: "row",
  },
  input: {
    marginBottom: 15,
  },
  largeDevicesInput: {
    flex         : 1,
    marginBottom : 10,
  },
});

export const textStyles = {
  message: {
    fontSize     : 14,
    marginBottom : 10,
  },
};
